import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...rest }, ref) => (
    <input
      ref={ref}
      className={cn(
        'block w-full rounded border border-slate-300 bg-white px-3 py-2 text-sm',
        'shadow-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500',
        'disabled:bg-slate-100',
        className,
      )}
      {...rest}
    />
  ),
);
Input.displayName = 'Input';
